import { useState } from "react";
import { Link } from "react-router-dom";
import { Gift, X } from "lucide-react";

const dismissedKey = (menuLink) => `clubPromptDismissed_${menuLink}`;
const joinedKey = (menuLink) => `clubJoined_${menuLink}`;

const readFlag = (key) => {
  try {
    return localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
};

// Small invitation to join the restaurant's customer club. Hidden once the
// guest has joined or dismissed it on this device.
export default function ClubJoinPrompt({ menuLink, restaurantName, className = "" }) {
  const [hidden, setHidden] = useState(() => readFlag(joinedKey(menuLink)) || readFlag(dismissedKey(menuLink)));

  if (!menuLink || hidden) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(dismissedKey(menuLink), "1");
    } catch {
      // ignore: it simply shows again next time
    }
    setHidden(true);
  };

  return (
    <aside className={`flex items-center gap-3 rounded-2xl border border-gray-200 bg-white p-3 text-right ${className}`} dir="rtl">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary_1 text-primary">
        <Gift size={19} aria-hidden="true" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-gray-800">عضو باشگاه {restaurantName || "مشتریان"} شوید</p>
        <p className="text-xs text-gray-500">از پیشنهادها و هدیه تولد باخبر شوید.</p>
      </div>
      <Link
        to={`/menu/${menuLink}/club`}
        className="inline-flex min-h-9 shrink-0 items-center rounded-lg bg-primary px-3 text-xs font-bold text-white hover:bg-[#e8731f]"
      >
        عضویت
      </Link>
      <button type="button" onClick={dismiss} className="shrink-0 rounded-lg p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600" aria-label="بستن">
        <X size={16} aria-hidden="true" />
      </button>
    </aside>
  );
}
